import { render, staticRenderFns } from "./OrderHeader.vue?vue&type=template&id=026df9ca&"
import script from "./OrderHeader.vue?vue&type=script&lang=js&"
export * from "./OrderHeader.vue?vue&type=script&lang=js&"
import style0 from "./OrderHeader.vue?vue&type=style&index=0&id=026df9ca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports